import React from "react";
import { ImagePicker } from 'react-file-picker'
import _ from '../utils/languages/languages';

export default class ImageInput extends React.Component {

    constructor (props){
        super(props);

        this.state = {
            base64: this.props.value
        }
    }

    render (){

        const readOnly = this.props.readOnly;

        if (readOnly == true){
            return (
            <div style={mainClass}>
            <div style={name}>{this.props.name}</div>
            <div style={{
                backgroundImage: 'url("data:' + this.state.base64 + '")',
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                width: '150px',
                height: '150px',
                border: '1px solid #888888',
                marginBottom: '10px',
                display: this.state.base64 === undefined ? 'none' : 'block',

            }} >
            </div>
            </div>
        );
        }
        return ( 
        <div style={mainClass}>
            <div style={name}>{this.props.name}</div>
            <div style={{
                backgroundImage: 'url("data:' + this.state.base64 + '")',
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                width: '150px',
                height: '150px',
                border: '1px solid #888888',
                marginBottom: '10px',
                display: this.state.base64 === undefined ? 'none' : 'block',

            }} >
            </div>

            <ImagePicker
                extensions={['jpg', 'jpeg', 'png']}
                dims={{minWidth: 100, maxWidth: 3000, minHeight: 100, maxHeight: 3000}}
                onChange={base64 => {
                    this.setState({base64: base64});
                    if (this.props.onChange)
                        this.props.onChange(base64)
                }}
                onError={errMsg => {
                } } >
                <button>
                Load
                </button>

            </ImagePicker>

            <div style={{position: 'absolute', top: 0, right: 0, padding: 15, fontSize: '20px', cursor: 'pointer'}}
                onClick={() => {this.setState({base64: ''});
                        if (this.props.onChange)
                            this.props.onChange('')}
                    }
                >X</div>

        </div>
        )
    }


}

const mainClass = {
    padding: '10px',
    width: '200px',
    position: 'relative'
}

const name = {
    
}

const picture = {


}

const inputText = {
    width: '300px'
}